export const getVimeoIdFromUrl = (url: string) => {
  const match = /vimeo.*\/(\d+)/i.exec(url)
  if (match) return match[1]
}
